import React from 'react';

import { Helmet } from 'react-helmet-async';
import { defineMessages, useIntl } from 'react-intl';

import { CateringPage } from 'components/features/catering-page';

const Catering = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Helmet title={formatMessage(messages.catering)} />
      <CateringPage />
    </>
  );
};

export default Catering;
const messages = defineMessages({
  catering: {
    id: 'catering',
    defaultMessage: 'Catering',
    description: 'Text for the call to action (button)',
  },
});
